import UpdateFlowBuilder from './components/UpdateFlowBuilder';
import CreateFlowBuilder from './components/CreateFlowBuilder';

export default {
  Create: CreateFlowBuilder,
  Update: UpdateFlowBuilder,
};
